import React from "react";
import MainPopover from "views/pages/manage/common/a-popover";
import { ReactComponent as CsvIcon } from "assets/img/svg/excel.svg";
import { ReactComponent as DownloadIcon } from "assets/img/svg/fi_download.svg";
import { Card, CardBody } from "reactstrap";
import { ReactComponent as ExcelIcon } from "../../../../../../../assets/img/svg/excel.svg";
// import AButton from "../../../../common/form-fields-mui/AButton";
// import styles from '../styles.module.scss';
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { downLoadFile, getDownloadTemplateUrl } from "./utils";
import { bulkPayModeUploadDropdown, paymodeNameMpping } from "./constant";

const DownloadFiles = ({accessibePaymodeTemList }) => {

  const downloadHandler = async (item) => {
    const res = await getDownloadTemplateUrl(item)
    console.log(res, 'download')
    await downLoadFile(res?.['Template Url'])
  }
  return (<Card className="mb-0">
    <CardBody>
      <div className="large-text">Download template</div>
      {accessibePaymodeTemList?.map(item => (
        <div className="d-flex justify-content-between" style={{ marginTop: '24px' }}>
          <div>
            <ExcelIcon className=' mr-2' style={{
              width: '20.81px',
              height: '19.349px'
            }} />
            <span className='regular-large'>{paymodeNameMpping?.[item?.value]}</span>
          </div><div>
            <DownloadIcon className=' ml-2 cursor' style={{
              width: '24px',
              height: '24px'
            }} onClick={() => downloadHandler(item)} />
          </div>
        </div>
      ))

      }
    </CardBody>
  </Card>


  );
};

export default DownloadFiles;
